import { FRONTEND_HOST, STATIC_CDN_IMAGES } from "@/config/constants";
import { ArticleJsonLd, NextSeo } from "next-seo";
import { IStaticPageSEO } from "./interfaces";
import { useRouter } from "next/router";
import MetaSeo from "./Meta";

const StaticPageSEO = (props: IStaticPageSEO) => {
  const router = useRouter();

  const url = `${FRONTEND_HOST}${router.asPath.split("?")[0]}`;

  return <>
    <MetaSeo title={props.title} description={props.description} keywords={props.keywords} />
    <ArticleJsonLd
      type="Article"
      url={url}
      title={props.title}
      keywords={[...props.keywords ?? [props.title]].join()}
      description={props.description || props.title}
      dateCreated={props.updatedAt}
      datePublished={props.updatedAt}
      dateModified={props.updatedAt}
      publisherName="Doubtnut"
      publisherLogo={`${STATIC_CDN_IMAGES}/logo_big_tag_compressed.png`}
      authorName={{
        type: "Organization",
        name: "Doubtnut",
        url: FRONTEND_HOST,
      }}
      images={props.images ?? []}
      isAccessibleForFree={true}
    />
  </>
}

export default StaticPageSEO;